<template>
    <ais-refinement-list
        :attribute="attribute"
        :sort-by="['name:asc']"
        :limit="5"
        v-show="! disableFilterConditions"
        show-more
        :show-more-limit="showMoreLimit"
        v-slot="{
                items,
                isShowingMore,
                isFromSearch,
                canToggleShowMore,
                refine,
                createURL,
                toggleShowMore,
                searchForItems
            }"
    >
            <filter-collapse
                :title="label"
                v-show="items.length > 0"
                :is-open="isOpen"
            >

                <template #badge>
                    <ais-current-refinements
                        :included-attributes="includedAttributes"
                        v-slot="{ items }"
                    >
                        <div v-if="items.length > 0">
                            {{ items[0] && items[0].refinements.length }}
                        </div>
                    </ais-current-refinements>
                </template>

                {{ disableFilterIfOnlyNoValue(items) }}


                <div class="algolia-listing-filters__filter-items-checkbox">
                    <div
                        v-for="(item, index) in items"
                        :key="item.value"
                        :class="disableForPriceReductionNoValue(item) ? '' : 'algolia-listing-filters__filter-item-wrapper'"
                    >
                        <label
                            class="algolia-listing-filters__filter-item-checkbox-wrapper"
                            :for="`${attribute}_${index}`"
                            v-show="! disableForPriceReductionNoValue(item)"
                        >
                            <input
                                :id="`${attribute}_${index}`"
                                type="checkbox"
                                :checked="item.isRefined"
                                hidden
                                @change="refine(item.value)"
                                class="algolia-listing-filters__filter-item-checkbox"
                            />
                            <span
                                class="algolia-listing-filters__filter-item-checkbox-checkmark"
                            ></span>
                            <div
                                class="d-flex align-items-start w-100 justify-content-between"
                            >
                                <span
                                    v-if="item.value === '1'"
                                    class="algolia-listing-filters__filter-item-label"
                                >
                                    {{ $t('algoliaSearch.filters.priceReduction.on')}}
                                </span>
                                <span
                                    v-else-if="item.value === '0'"
                                    class="algolia-listing-filters__filter-item-label"
                                >
                                    {{ $t('algoliaSearch.filters.priceReduction.off')}}
                                </span>
                                <span
                                    v-else
                                    class="algolia-listing-filters__filter-item-label"
                                >
                                    {{ item.value }}
                                </span>
                                <span
                                    v-if="showItemCount"
                                    class="algolia-listing-filters__filter-item-count"
                                    >({{ item.count.toLocaleString() }})</span
                                >
                            </div>
                        </label>
                    </div>
                </div>
                <div
                    @click="toggleShowMore"
                    v-show="canToggleShowMore && !isShowingMore"
                    class="algolia-listing-filters__show-more-button"
                >
                    <i class="fa fa-chevron-down"></i>
                    <span>{{
                        $t("algoliaSearch.refinementListViewMore")
                    }}</span>
                </div>
                <div
                    @click="toggleShowMore"
                    v-show="canToggleShowMore && isShowingMore"
                    class="algolia-listing-filters__show-more-button"
                >
                    <i class="fa fa-chevron-up"></i>
                    <span>{{ $t("algoliaSearch.refinementListViewLess") }}</span>
                </div>
            </filter-collapse>
    </ais-refinement-list>
</template>

<script setup>
import { AisCurrentRefinements, AisRefinementList } from "vue-instantsearch/vue3/es";
import FilterCollapse from "./FilterCollapse";
import { computed, ref, toRefs } from "vue";

const props = defineProps({
    attribute: {
        type: String,
        required: true
    },
    label: {
        type: String,
        required: true
    },
    isMobileStyling: {
        type: Boolean,
        default: false
    },
    showItemCount: {
        type: Boolean,
        default: true
    },
    isOpen: {
        type: Boolean,
        default: false
    },
    limit: {
        type: [String, Number],
        default: 30,
    }
});

const { attribute, limit } = toRefs(props);

const includedAttributes = ref(attribute.value);
const disableFilterConditions = ref(false);

const showMoreLimit = computed(() => {
    if (limit.value <= 5) {
        return 30;
    }

    return Number(limit.value);
});

const attributeIsPriceReduction = computed(() => attribute.value === 'combinations.price_reduction');

const disableForPriceReductionNoValue = (item) => {
    return attributeIsPriceReduction.value && item.value === '0';
}

const hasValueNo = (items) => items[0]?.value === '0'

const disableFilterIfOnlyNoValue = (items) => {
    if (items.length <= 1 && attributeIsPriceReduction.value) {
        if (hasValueNo(items)) {
            disableFilterConditions.value = true;
        }
    }

    return '';
}

</script>
